// Add this constants file for app-wide prefixes
export const APP_PREFIX = 'olivia_salon_';
export const pinkColor = '#e7348e';
export const STORAGE_KEYS = {
    MEMBERS: `${APP_PREFIX}members`,
    SALES: `${APP_PREFIX}sales`,
    MENU: `${APP_PREFIX}menu`,
    // Add other keys as needed
};

export const GOLD_MEMBERSHIP_MIN_SPEND = 399;